import { MessageBadgeOutlineIcon } from './MessageBadgeOutlineIcon';

/**
 * author: Google
 * id E3DAA0CA-4F39-49E0-9D3D-5306D764167D
 * name message-badge-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-badge-outline.svg
 * tags
 * - Notification 
 */
export const MessageUnreadOutlineIcon = MessageBadgeOutlineIcon;
export default MessageUnreadOutlineIcon